export default class GetStartedFormController {
  submit() {
    this.onSubmit({ model: this.model });
  }
}
